export const faqItems = [
  {
    question: 'Wat doen jullie precies?',
    answer: 'Wij zorgen dat jouw CRM schoon, gestructureerd en betrouwbaar blijft. Dat betekent: data opschonen, fouten voorkomen en het CRM doorlopend beheren, zodat sales en management erop kunnen vertrouwen.'
  },
  {
    question: 'Voor welke CRM-systemen werken jullie?',
    answer: "Wij werken o.a. met HubSpot, Salesforce, Microsoft Dynamics en Pipedrive. Andere CRM's zijn bespreekbaar na een korte scan."
  },
  {
    question: 'Werken jullie projectmatig of met abonnementen?',
    answer: 'Altijd beide: we starten met een eenmalige opschoning (reset), daarna werken we met een vast maandabonnement. Zo voorkom je dat het CRM na een paar maanden weer vervuilt.'
  },
  {
    question: 'Waarom is een start-opschoning verplicht?',
    answer: 'Omdat beheren alleen werkt als de basis klopt. Zonder opschoning blijf je symptomen bestrijden in plaats van het probleem oplossen.'
  },
  {
    question: 'Wat levert dit ons concreet op?',
    answer: 'Betrouwbare rapportages, minder discussie over cijfers, meer focus voor sales, minder fouten en dubbel werk, rust en eigenaarschap rondom data. Kort: betere beslissingen met minder gedoe.'
  },
  {
    question: 'Wie voert het werk uit?',
    answer: 'Je hebt één vast aanspreekpunt in Nederland. De uitvoering gebeurt volgens vaste processen en kwaliteitscontroles. Geen losse freelancers, geen wisselende gezichten.'
  },
  {
    question: 'Hoe zit het met privacy en AVG?',
    answer: 'Wij werken volgens AVG-richtlijnen, dataminimalisatie en rol- en toegangsbeheer. We werken alleen met data die nodig is voor de opdracht en leggen afspraken vast in een verwerkersovereenkomst.'
  },
  {
    question: 'Hebben jullie toegang tot ons hele CRM?',
    answer: 'Alleen wat nodig is. Toegang wordt afgestemd per rol en kan altijd worden aangepast of ingetrokken.'
  },
  {
    question: 'Hoe snel kunnen jullie starten?',
    answer: 'Meestal binnen 1–2 weken na akkoord. Na de intake plannen we direct de CRM-scan in.'
  },
  {
    question: 'Wat kost het?',
    answer: 'Eenmalige opschoning: vanaf €1.500. Maandelijks beheer: vanaf €750 per maand. Na de scan ontvang je altijd een vaste prijs, geen verrassingen achteraf.'
  },
  {
    question: 'Zitten we vast aan lange contracten?',
    answer: 'Nee. Onze abonnementen hebben een looptijd van 6 of 12 maanden. We geloven in blijven omdat het werkt, niet omdat het moet.'
  },
  {
    question: 'Is dit niet iets wat we zelf kunnen doen?',
    answer: 'In theorie wel. In de praktijk ontbreekt vaak tijd, eigenaarschap en consistentie. Wij zijn goedkoper dan interne tijd én zorgen dat het structureel gebeurt.'
  },
  {
    question: 'Wat als we later willen uitbreiden?',
    answer: 'Dat kan. Veel klanten breiden uit naar functioneel CRM-beheer, datamigraties, procesdocumentatie of operations support. Je groeit met ons mee.'
  }
];
